module.exports = __webpack_public_path__ + "img/chicken-sticker.e959c6f9.svg";